import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import AccountBookWizard from "@/pages/account/AccountBookWizard";
import { usePageMeta } from "@/hooks/usePageMeta";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AccountBook() {
    usePageMeta({ title: "Book a campaign · NOXN", description: "Book your NOXN billboard campaign." });
    // Resume support for legacy `?draft=<token>` links — hydrate sessionStorage
    // before the wizard reads it.
    const [params] = useSearchParams();
    const draftToken = params.get("draft");
    const [ready, setReady] = useState(!draftToken);
    useEffect(() => {
        if (!draftToken) return;
        axios.get(`${API}/wizard-drafts/${draftToken}`)
            .then(({ data }) => {
                try { sessionStorage.setItem("noxn.wizard.v2", JSON.stringify(data.values || {})); } catch (e) { /* ignore */ }
                setReady(true);
            })
            .catch(() => {
                toast.error("That saved draft was not found or has expired.");
                setReady(true);
            });
    }, [draftToken]);
    if (!ready) return null;
    return <AccountBookWizard />;
}
